import { createContext } from "react";

// Split so opening/closing the modal (modal context) never re-renders the grid cells (data context).
export const StatusTrackerDataContext = createContext(null);
export const StatusTrackerModalContext = createContext(null);
